import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Build with ShipStation API',
    id: 'Ixy+67',
    description: 'Title of the banner when the user cannot create API keys because of the plan/features',
  },
  firstParagraph: {
    defaultMessage: 'ShipStation’s API & SDKs provide everything you need to integrate shipping functionality into your platforms.',
    id: 'ou0IVX',
    description: 'First content of the banner when the user cannot create API keys because of the plan/features',
  },
  secondParagraph: {
    defaultMessage:
      'To access our <b>shipping API endpoints</b>, upgrade to the <b>Gold</b> plan or higher. To access our <b>inventory endpoints</b>, enable the Inventory API add-on.',
    id: '1z/fzo',
    description: 'Second content of the banner when the user cannot create API keys because of the plan/features',
  },
  upgradeButtonLabel: {
    defaultMessage: 'Upgrade plan',
    id: 'u9Z0Vb',
    description: 'Button label for the banner about upgrading a plan',
  },
  imageAlt: {
    description: 'Image Alt text for screen readers',
    defaultMessage: 'ShipStation plan upgrade',
    id: '6hBq8j',
  },
  enableInventoryButtonLabel: {
    description: 'Label for the button to redirect the user into a new page',
    defaultMessage: 'Enable Inventory API',
    id: 'yIVCac',
  },
});
